import { render, staticRenderFns } from "./OnboardingPageStep1.vue?vue&type=template&id=e1ef0810&"
import script from "./OnboardingPageStep1.vue?vue&type=script&lang=ts&"
export * from "./OnboardingPageStep1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports